// src/layouts/DashboardLayout.jsx
import React, { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Outlet } from "react-router-dom";
import Header from "../components/Header";
import Sidebar from "../components/Sidebar";
import MenuIcon from "@mui/icons-material/Menu";
import { IconButton } from "@mui/material";
import {
  toggleSidebar,
  setMobileView,
} from "../store/uiSlice";

const MOBILE_BREAKPOINT = 768; // px

const DashboardLayout = () => {
  const dispatch = useDispatch();
  const isOpen = useSelector((state) => state.ui.sidebarOpen);
  const darkMode = useSelector((state) => state.ui.darkMode);
  const isMobileView = useSelector((state) => state.ui.isMobileView);

  // Keep track of window width to set mobileView
  useEffect(() => {
    const onResize = () => {
      const mobile = window.innerWidth < MOBILE_BREAKPOINT;
      dispatch(setMobileView(mobile));
    };
    window.addEventListener("resize", onResize);
    onResize(); // initialize
    return () => window.removeEventListener("resize", onResize);
  }, [dispatch]);

  // Toggle sidebar open/closed
  const handleToggle = () => {
    dispatch(toggleSidebar());
  };

  // compute classes
  const sidebarWidthClass = !isMobileView
    ? isOpen
      ? "md:w-64"
      : "md:w-16"
    : isOpen
    ? "w-64"
    : "w-0";

  const contentMarginClass = !isMobileView
    ? isOpen
      ? "md:ml-64"
      : "md:ml-16"
    : "ml-0";

  return (
    <div className={darkMode ? "dark" : ""}>
      <div className="min-h-screen bg-gray-50 dark:bg-coolGray-850 transition-colors duration-200 flex flex-col">
        {/* Header + optional mobile hamburger */}
        <header className="fixed top-0 left-0 right-0 z-50 flex items-center bg-white dark:bg-gray-900 shadow-sm h-16 px-4 md:px-6">
          {isMobileView && (
            <IconButton
              onClick={handleToggle}
              className="text-gray-700 dark:text-gray-300 mr-2"
              aria-label="Toggle sidebar"
              size="large"
            >
              <MenuIcon fontSize="inherit" />
            </IconButton>
          )}
          {/* your existing header */}
          <Header />
        </header>

        {/* Overlay when sidebar open on mobile */}
        {isMobileView && isOpen && (
          <div
            onClick={handleToggle}
            className="fixed inset-0 bg-black bg-opacity-40 z-40 transition-opacity"
          />
        )}

        {/* Sidebar + Main */}
        <div className="flex flex-1 pt-16">
          {/* Sidebar */}
          <aside
            className={`
              fixed top-16 left-0 h-[calc(100vh-4rem)] z-50
            bg-gray-50overflow-y-auto
              ${sidebarWidthClass}
              transition-[width] duration-300 ease-in-out
            `}
          >
            <Sidebar />
          </aside>

          {/* Main content */}
         <main
  className={`
    flex-1 transition-all duration-300
  `}
  style={{
    marginLeft:
      !isMobileView
        ? isOpen
          ? 'calc(256px - 190px)' // 256 sidebar width minus 40px overlap
          : 'calc(64px - 190px)' // 64 sidebar width minus 40px overlap
        : '0',
  }}
>
  
            <div className="p-4 md:p-6 w-full min-h-[calc(100vh-4rem)]">
              <Outlet />
            </div>
          </main>
        </div>
      </div>
    </div>
  );
};

export default DashboardLayout;
